import { motion } from "framer-motion";
import { MessageCircle, Instagram, Mail } from "lucide-react";
import CelebrationButton from "@/components/ui/CelebrationButton";
import { SERVICES, WHATSAPP_URL } from "@/data/services";
import { scrollToId } from "@/hooks/useLenis";

export default function CtaFooter() {
  const go = (e, href) => {
    e.preventDefault();
    scrollToId(href);
  };

  return (
    <footer
      id="kontak"
      data-testid="cta-footer"
      className="relative overflow-hidden bg-[#0B132B]"
    >
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 50% 18%, rgba(201,162,39,0.16), transparent 65%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-6 pb-12 pt-28 lg:px-10 lg:pt-40">
        <div className="mx-auto max-w-3xl text-center">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="font-mono text-[11px] tracking-[0.4em] text-[#C9A227]"
          >
            06 — MULAI
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="font-display mt-6 text-5xl leading-[1.05] text-[#F6F0E6] md:text-6xl"
            data-testid="footer-headline"
          >
            Momenmu berikutnya,{" "}
            <em className="text-[#E8C98A]">layak dirayakan</em>.
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.25 }}
            className="mx-auto mt-6 max-w-md text-[#F6F0E6]/60"
          >
            Ceritakan momenmu hari ini — kami balas secepat lentera menyala.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-10 flex justify-center"
          >
            <CelebrationButton
              variant="gold"
              href={WHATSAPP_URL}
              testId="footer-cta-whatsapp"
              data-magnetic
              className="px-10 py-5 text-lg"
            >
              <MessageCircle size={20} />
              Mulai Rayakan Momenmu
            </CelebrationButton>
          </motion.div>
        </div>

        <div className="mt-24 grid gap-10 border-t border-white/10 pt-12 md:grid-cols-3">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="font-display text-2xl text-[#F6F0E6]">
                Ihtifaal
              </span>
              <span className="font-mono text-[10px] tracking-[0.3em] text-[#C9A227]">
                احتفال
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#F6F0E6]/50">
              Studio perayaan digital — merayakan momen penting hidupmu, satu
              website dalam satu waktu.
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-[#F6F0E6]/40">
              LAYANAN
            </p>
            <ul className="mt-4 space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <a
                    href="#layanan"
                    onClick={(e) => go(e, "#layanan")}
                    data-testid={`footer-link-${s.id}`}
                    className="text-sm text-[#F6F0E6]/60 transition-colors hover:text-[#E8C98A]"
                  >
                    {s.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-[#F6F0E6]/40">
              KONTAK
            </p>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-contact-whatsapp"
                  className="inline-flex items-center gap-2 text-sm text-[#F6F0E6]/60 transition-colors hover:text-[#E8C98A]"
                >
                  <MessageCircle size={14} /> +62 851-9609-1527
                </a>
              </li>
              <li>
                <a
                  href="mailto:ihtifaal@gmail.com"
                  data-testid="footer-contact-email"
                  className="inline-flex items-center gap-2 text-sm text-[#F6F0E6]/60 transition-colors hover:text-[#E8C98A]"
                >
                  <Mail size={14} /> ihtifaal@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/ihtifaal"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-contact-instagram"
                  className="inline-flex items-center gap-2 text-sm text-[#F6F0E6]/60 transition-colors hover:text-[#E8C98A]"
                >
                  <Instagram size={14} /> @ihtifaal
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-[#F6F0E6]/40 sm:flex-row">
          <p>© 2026 Ihtifaal — احتفال. Semua momen berhak dirayakan.</p>
          <p>Dibuat dengan cahaya di Indonesia.</p>
        </div>
      </div>
    </footer>
  );
}
